import type { Translation } from '../types/translation';

export default (key: string, translations: Translation[]) => {
  return translations.find((trans) => trans.key === key)?.value;
};
